import React from 'react'
import ReactDOM from 'react-dom'
import LogRocket from 'logrocket'
import setupLogRocketReact from 'logrocket-react'
import { MemoryRouter as Router } from 'react-router-dom'
import firebase from 'firebase'
import Analytics from 'analytics'
import segmentPlugin from '@analytics/segment'

import { auth, firestore } from './shared/Firebase'
import './styles/index.css'
import App from './App'

export const analytics = Analytics({
  app: 'website',
  plugins: [
    segmentPlugin({
      writeKey: 'dv1UuUHQQyF02kGYVREvGDDEobC8GurY'
    })
  ]
})

auth.signInAnonymously().then(async (userCredential) => {
  if (userCredential.user) {
    const uid = userCredential.user.uid
    const entryDoc = await firestore.collection('entries').doc(uid).get()

    analytics.identify(uid)

    if (!entryDoc.exists) {
      entryDoc.ref.set({
        id: null,
        email: null,
        firstName: null,
        lastName: null,
        mailingList: false,
        zip: null,
        videoUrl: null,
        downloaded: false,
        created_at: firebase.firestore.FieldValue.serverTimestamp()
      })
    }
  }
})

LogRocket.init('phadqs/op-lg')
setupLogRocketReact(LogRocket)

ReactDOM.render(
  <React.StrictMode>
    <Router initialEntries={['/']}>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('ddd-client')
)
